import { render, staticRenderFns } from "./header.vue?vue&type=template&id=8fa7a606&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=8fa7a606&prod&lang=scss"
import style1 from "./header.vue?vue&type=style&index=1&id=8fa7a606&prod&lang=scss&scoped=true"
import style2 from "./header.vue?vue&type=style&index=2&id=8fa7a606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa7a606",
  null
  
)

export default component.exports